import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-h6" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" ➡️ Slide to confirm ➡️ ")

interface ConfirmPopupViewModel {
  Title: string
  Body: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmPopup',
  props: {
    vm: null
  },
  setup(__props: any) {

const props = __props as { vm: ConfirmPopupViewModel }



return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_slide_item = _resolveComponent("q-slide-item")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, null, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, _toDisplayString(props.vm.Title), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, { class: "q-pt-none" }),
          _createVNode(_component_q_slide_item, {
            onLeft: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('ok', { hasSlid: true })))
          }, {
            left: _withCtx(() => [
              _createVNode(_component_q_icon, { name: "done" })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_q_item, { class: "bg-secondary" }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_section, null, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})